'use client';

import Icon from './Icon';
import svg from 'sprites/arrow.svg';

export default function IconArrow({
  className = 'w-[15px] h-[26px] fill-none stroke-brown'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
